module.exports = __webpack_public_path__ + "static/img/fullscreen-image_success.56f6aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/fullscreen-image_success.png
// module id = cu4k
// module chunks = 0